import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'list': [],
  'courseStatusSelected': null,
  'loading': false,
};

export const wtsCoursesStatus = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WTS_COURSES_STATUS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_COURSES_STATUS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_COURSES_STATUS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CHANGE_WTS_COURSE_STATUS_SELECTED]: (state, action) => ({
      ...state,
      'loading': false,
      'courseStatusSelected': action.payload,
    }),
  })(state, action);
};
